import { useState, useRef, useEffect, useContext } from "react";
import { Button } from "primereact/button";

import GlobalContext                      from "../../isp._comun/contexto/GlobalContext";
import * as TipoDeError                   from "../../isp._comun/servicios/Errores";
import useHandlerDeComandoConSesionActiva from '../../isp.pantalla.principal/componentes/useHandlerDeComandoConSesionActiva'
import ServicioDeCerradoDeSesion          from "../../isp.servicios.idyacceso/ServicioDeCerradoDeSesion";

import ActionCerrarSesion from "../reductores/acciones/seguridad/ActionCerrarSesion";
// import * as TipoDeErrorSeguridad from "../../servicios/Errores";
// import * as TipoDeError from "../../../_comun/Errores";

// import { NotificacionToastDeError } from "../../../_comun/componentes/widgets/Notificaciones";
// import CodigoDeError from "../../../_comun/CodigosDeErrorDeRespuestas.json";
// import DataDeRespuestas_Comun from "../../../_comun/DataEstaticaDeRespuestas.json";
// import ActionCancelarCerrarSesion from "../../../_principal/reductores/acciones/seguridad/ActionCancelarCerrarSesion";


const PanelInteractivoDeCerrarSesion = () => {
    const { 
        cargarPantallaLogin, 
        usuario, 
        dispatchPrincipal, 
        // notificar 
    } = useContext(GlobalContext);

    // const [sensorDeCerrarSesion, setSensorDeCerrarSesion] = useState(false);
    const [banderaCerrandoSesion, setBanderaCerrandoSesion] = useState(false);

    // const isMounted = useRef(false);
    // let sensorDeCerrarSesion = useRef(false);

    /* useEffect(() => {
        if (isMounted.current) {
            cerrarSesion();
            // console.log("hola");
            // registrarClienteAFacturar();
        } else {
            isMounted.current = true;
        }
    }, [sensorDeCerrarSesion]); */

    const cerrarSesion = useHandlerDeComandoConSesionActiva( async () => {
        try {
            await new ServicioDeCerradoDeSesion().ejecutar();
            cargarPantallaLogin();
        } catch (error) {
            /*if (error instanceof TipoDeError.ErrorEnIdSesion) {
                cargarPantallaLogin();
                return;
            }*/
            if (error instanceof TipoDeError.ErrorTecnico) {
                setBanderaCerrandoSesion(false);
                // dispatchPrincipal(new ActionCancelarCerrarSesion());

                /* let nombreDeError = error.constructor.name;
                notificar(
                    new NotificacionToastDeError(
                        DataDeRespuestas_Comun[nombreDeError].titulo,
                        DataDeRespuestas_Comun.labelCodigoError,
                        CodigoDeError[nombreDeError],
                        DataDeRespuestas_Comun[nombreDeError].descripcion
                    )
                ); */
                throw error;
            }
            
        }
    });



    return (
        <>
            {/* <PantallaLogin
            nombreUsuario={nombreUsuario}
            contraseña={contraseña}
            loading={loading}
            banderasError={banderasError}
            setearNombreUsuario={setearNombreUsuario}
            setearContraseña={setearContraseña}
            manejarLogueo={manejarLogueo}
            ref={refPantallaLoguin}
        /> */}

            <h1 className="mb-1">{usuario.alias}</h1>
            <Button
                label="Salir"
                icon="pi pi-power-off"
                className="p-1 m-0 w-20"
                onClick={() => {
                    setBanderaCerrandoSesion(true);
                    // setSensorDeCerrarSesion(!sensorDeCerrarSesion);
                    dispatchPrincipal(new ActionCerrarSesion());
                    cerrarSesion();
                }}
                // onClick={()=>notificarEventoDeSeguridad(new Evento.CerroSesion())}
                loading={banderaCerrandoSesion}
            />
        </>
    );
};

export default PanelInteractivoDeCerrarSesion;
